// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface ReadNotificationRequestPayload {
  id: number;
  success: () => void;
}

export interface ReadNotificationSuccessPayload {
  id: number; // for updating
}

export interface ReadNotificationFailPayload {
  error: Error;
}

export const readNotificationActions = createAsyncAction(
  'elearning/POST_READ_NOTIFICATION',
  'elearning/POST_READ_NOTIFICATION_SUCCESS',
  'elearning/POST_READ_NOTIFICATION_FAIL'
)<
  ReadNotificationRequestPayload,
  ReadNotificationSuccessPayload,
  ReadNotificationFailPayload
>();
